export default __webpack_public_path__ + "static/media/page_material_list.c80ed373.svg";